module.exports = __webpack_public_path__ + "img/Al-Ghadeer2.e8e7967f.jpeg";